import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="site-header">
      <div className="container">
        <Link to="/" className="logo">
          <span className="logo-flora">Flora</span>
          <span className="logo-care">Care</span>
        </Link>
        <nav className="main-nav">
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>

            {/* 🛡️ Login ke baad dikhne waale saare links */}
            {user && (
              <>
                <li>
                  <Link to="/tracker">Tracker</Link>
                </li>
                <li>
                  <Link to="/babycare">BabyCare</Link>
                </li>
                <li>
                  <Link to="/sti-assessment">STI Quiz</Link>
                </li>
                <li>
                  <Link
                    to="/floracare-plus"
                    style={{ color: "#e91e63", fontWeight: "bold" }}
                  >
                    FloraCare+{" "}
                    <i
                      className="fas fa-crown"
                      style={{ color: "#ffd700" }}
                    ></i>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
        <div className="header-actions">
          {user ? (
            <>
              <span className="user-greeting">
                Hi, {user.name.split(" ")[0]}!
              </span>
              <button onClick={handleLogout} className="btn btn-outline">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-outline">
                Login
              </Link>
              <Link to="/signup" className="btn btn-primary">
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
